import { render, staticRenderFns } from "./bidResetInvitationsHandler.vue?vue&type=template&id=2db50f11"
import script from "./bidResetInvitationsHandler.vue?vue&type=script&lang=js"
export * from "./bidResetInvitationsHandler.vue?vue&type=script&lang=js"
import style0 from "./bidResetInvitationsHandler.vue?vue&type=style&index=0&id=2db50f11&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports